<template>
  <div id="footerblock">
      <div class="container">
        <div class="content has-text-centered">
          <p>
            <strong>{{ appname }}</strong><a :href="website"> ООО "ЦиК АлеКоН"</a> Версия {{ version }}
          </p>
        </div>
      </div>
  </div>
</template>

<script>
import config from '../../appsettings.js'
export default {
  name: "appfooter",
  data() {
    return {
      appname: config.APP_NAME,
      website: config.VENDOR_WEBSITE,
      version: config.VERSION
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/appfooter.vue